import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IOrderMenuItem } from '../models/order-menu.models';
import { ColorService } from '../../../v2-components/services/color.service';

@Component({
  selector: 'v2-item-badge',
  template: `
    <v2-forked-edge-banner
      [hexColor]="
        item.inStock && !item.isUnavailableDueToAlcohol
          ? item.badge.backgroundColor
          : colorService.inactiveGrey
      "
      [size]="size"
    >
      <span
        class="global-header-font"
        [style.color]="
          item.inStock && !item.isUnavailableDueToAlcohol
            ? item.badge.textColor
            : colorService.white
        "
      >
        {{ item.badge.text }}
      </span>
    </v2-forked-edge-banner>
  `,
  styles: [
    `
      .global-header-font {
        display: block;
        font-size: 12px;
        line-height: 1.4;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class V2ItemBadge {
  @Input() item!: IOrderMenuItem;
  @Input() size: 'small' | 'medium' | undefined | null;

  constructor(public colorService: ColorService) {}
}
